const categoryLabels: Record<string, string> = {
    OPERATIONAL: 'Operational',
    COMPLIANCE: 'Compliance',
    INVESTMENT: 'Investment',
    'IT-CYBER': 'IT-Cyber',
    'HEALTH & SAFETY': 'Health & Safety',
    FRAUD: 'Fraud',
    'BUSINESS CONTINUITY': 'Business Continuity',
    FACILITIES: 'Facilities',
    OTHER: 'Other'
};

export function formatIncidentCategory(value?: string | null) {
    if (!value) return '—';
    return categoryLabels[value] ?? value.split('_').map(part => part ? part[0] + part.slice(1).toLowerCase() : part).join(' ');
}

export interface IncidentStatusOption {
    value: string;
    label: string;
    meaning: string;
    assignable: boolean;
}

export const incidentStatusOptions: IncidentStatusOption[] = [
    { value: 'OPEN', label: 'Open', meaning: 'Incident has been reported but not yet assessed.', assignable: true },
    { value: 'UNDER_INVESTIGATION', label: 'Under Investigation', meaning: 'Investigation is ongoing.', assignable: true },
    { value: 'CORRECTIVE_ACTION_IN_PROGRESS', label: 'Corrective Action in Progress', meaning: 'Actions have been assigned and are being implemented.', assignable: true },
    { value: 'PENDING_VERIFICATION', label: 'Pending Verification', meaning: 'Corrective actions completed and awaiting validation by Risk/Compliance.', assignable: true },
    { value: 'CLOSED', label: 'Closed', meaning: 'Incident fully resolved and approved for closure.', assignable: false },
    { value: 'ESCALATED', label: 'Escalated', meaning: 'Incident referred to Executive Management or the Board due to severity.', assignable: true }
];

const legacyStatusLabels: Record<string, string> = {
    SUBMITTED: 'Open',
    UNDER_REVIEW: 'Open',
    INVESTIGATING: 'Under Investigation'
};

export function formatIncidentStatus(value?: string | null) {
    if (!value) return '—';
    return incidentStatusOptions.find(option => option.value === value)?.label
        ?? legacyStatusLabels[value]
        ?? value.split('_').map(part => part ? part[0] + part.slice(1).toLowerCase() : part).join(' ');
}

export function incidentStatusMeaning(value?: string | null) {
    if (!value) return '';
    return incidentStatusOptions.find(option => option.value === value)?.meaning ?? '';
}
